import { Schema } from "effect";
import * as z from "zod/v4";
import { SupportTicketId } from "../../../ids/definitions";
import { zodToEffectSchema } from "../../zod";
import { SUPPORT_TICKET_STATUSES } from "./support-ticket";

export const BulkSupportTicketActionZod = z.discriminatedUnion("_tag", [
  z.object({
    _tag: z.literal("setSupportTicketStatus"),
    status: z.enum(SUPPORT_TICKET_STATUSES),
  }),
  z.object({
    _tag: z.literal("setReadStatus"),
    status: z.enum(["read", "unread"]),
  }),
  z.object({ _tag: z.literal("setAssignee"), userId: z.string() }),
  z.object({ _tag: z.literal("addTags"), tagIds: z.array(z.string()) }),
  z.object({ _tag: z.literal("removeTags"), tagIds: z.array(z.string()) }),
]);

export const BulkSupportTicketAction = zodToEffectSchema(
  BulkSupportTicketActionZod,
);
export type BulkSupportTicketAction = typeof BulkSupportTicketAction.Type;

export const StartBulkSupportTicketActionInput = Schema.Struct({
  supportTicketIds: Schema.Array(SupportTicketId),
  action: BulkSupportTicketAction,
});
export type StartBulkSupportTicketActionInput =
  typeof StartBulkSupportTicketActionInput.Type;

export const StartBulkSupportTicketActionResponse = Schema.Struct({
  workflowId: Schema.String,
});
export type StartBulkSupportTicketActionResponse =
  typeof StartBulkSupportTicketActionResponse.Type;
